import { render, staticRenderFns } from "./OfferSummary.vue?vue&type=template&id=65076516&scoped=true"
import script from "./OfferSummary.vue?vue&type=script&lang=ts"
export * from "./OfferSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65076516",
  null
  
)

export default component.exports